// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';

const StyledHero = styled.div`
  width: 100%;
  box-sizing: border-box;
  position: relative;


  .image {
    width: 100%;
    height: auto;
    display: block;
  }

  .link {
    display: block;
    cursor: pointer;
  }
`;

const Hero = {
  label: 'Hero',
  fields: {
    imageUrl: { type: 'text', label: 'Image URL' },
    imageAlt: { type: 'text', label: 'Image Alt' },
    linkUrl: { type: 'text', label: 'Link URL (optional)' },
    linkTarget: {
      type: 'radio',
      label: 'Link Target',
      options: [
        { label: 'Same tab', value: '_self' },
        { label: 'New tab', value: '_blank' },
      ],
    },
  },
  defaultProps: {
    imageUrl: 'https://picsum.photos/1920/600',
    imageAlt: '',
    linkUrl: '',
    linkTarget: '_self',
  },
  render: ({ imageUrl, imageAlt, linkUrl, linkTarget }) => {
    if (!imageUrl) return <></>;

    const image = (
      <img src={ imageUrl } alt={ imageAlt } className="image" />
    );

    return (
      <StyledHero>
        {linkUrl ? (
          <a
            href={ linkUrl }
            target={ linkTarget }
            rel={ linkTarget === '_blank' ? 'noopener noreferrer' : undefined }
            className="link"
          >
            {image}
          </a>
        ) : (
          image
        )}
      </StyledHero>
    );
  },
};

export { Hero };
